"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrInfoCard = void 0;
const react_1 = __importDefault(require("react"));
const fdr_help_overlay_styles_1 = require("./fdr-help-overlay.styles");
function FdrInfoCard({ infoCardImage, className, children, }) {
    return (react_1.default.createElement(fdr_help_overlay_styles_1.FdrInfoCardContentWrapper, { className: className },
        infoCardImage ? (react_1.default.createElement("div", { className: "info-card-icon" },
            react_1.default.createElement(fdr_help_overlay_styles_1.FdrInfoCardImage, { lazy: false, image: infoCardImage }))) : null,
        children));
}
exports.FdrInfoCard = FdrInfoCard;
//# sourceMappingURL=fdr-info-card.js.map